/**
 * @param {string} value
 * @returns {Promise<string | undefined>}
 */
export const hashWithSHA256 = async (value) => {
  if (!value) {
    return
  }
  const encoder = new TextEncoder()
  const data = encoder.encode(value)
  const hashBuffer = await crypto.subtle.digest('SHA-256', data)
  const hashArray = Array.from(new Uint8Array(hashBuffer))
  const hashHex = hashArray.map((b) => b.toString(16).padStart(2, '0')).join('')
  return hashHex
}
